import { __assign } from "tslib";
import { merge } from 'lodash';
import { defaultBreakpoints } from './defaultBreakpoints';
import { defaultThemeColors } from './defaultThemeColors';
import { defaultBadgeVariants } from './defaultBadgeVariants';
import { defaultTagVariants } from './defaultTagVariants';
import { defaultTheme } from './defaultTheme';
export var createTheme = function (customTheme) {
    var colors = __assign(__assign({}, defaultThemeColors), customTheme === null || customTheme === void 0 ? void 0 : customTheme.colors);
    var badgeVariants = merge({}, defaultBadgeVariants, {
        primary: {
            backgroundColor: colors.primaryLightest,
            color: colors.primaryDark,
        },
        success: {
            backgroundColor: colors.greenLightest,
            color: colors.greenDark,
        },
        danger: {
            backgroundColor: colors.redLightest,
            color: colors.redDark,
        },
        warning: {
            backgroundColor: colors.orangeLightest,
            color: colors.orangeDark,
        },
        info: {
            backgroundColor: colors.blueLightest,
            color: colors.blueDark,
        },
        grey: {
            backgroundColor: colors.greyLight,
            color: colors.greyDarker,
        },
    });
    var buttonVariants = merge({}, defaultTheme.variants.Button, {
        primary: {
            backgroundColor: colors.primary,
            color: colors.white,
            '&:hover': {
                backgroundColor: colors.primaryLight,
            },
            '&:active': {
                backgroundColor: colors.primaryDark,
            },
            '&:disabled': {
                backgroundColor: colors.primaryLightest,
            },
        },
        primaryText: {
            color: colors.primary,
            '&:hover': {
                color: colors.primaryDark,
            },
        },
        secondary: {
            borderColor: colors.primary,
            color: colors.primary,
            '&:hover': {
                backgroundColor: colors.primary,
                color: colors.white,
            },
            '&:active': {
                backgroundColor: colors.primaryDark,
                color: colors.white,
            },
            '&:disabled': {
                borderColor: colors.primaryLightest,
                color: colors.primaryLightest,
            },
        },
        tertiary: {
            borderColor: colors.greyDark,
            color: colors.secondary,
            '&:hover': {
                backgroundColor: colors.greyLightest,
            },
            '&:active': {
                backgroundColor: colors.greyLight,
            },
            '&:disabled': {
                backgroundColor: colors.white,
            },
        },
        grey: {
            backgroundColor: colors.white,
            borderColor: colors.grey,
            color: colors.greyDarkest,
            '&:hover': {
                borderColor: colors.greyDark,
            },
            '&:active': {
                backgroundColor: colors.greyLight,
            },
            '&:disabled': {
                borderColor: colors.grey,
                color: colors.grey,
            },
        },
        greyText: {
            color: colors.grey,
            '&:hover': {
                color: colors.greyDark,
            },
        },
        success: {
            color: colors.white,
            backgroundColor: colors.secondary,
            '&:hover': {
                backgroundColor: colors.secondaryLight,
            },
            '&:active': {
                backgroundColor: colors.secondaryDark,
            },
            '&:disabled': {
                backgroundColor: colors.secondaryLightest,
            },
        },
        warning: {
            backgroundColor: colors.orange,
            color: colors.white,
            '&:hover': {
                backgroundColor: colors.orangeLight,
            },
            '&:active': {
                backgroundColor: colors.orangeDark,
            },
            '&:disabled': {
                backgroundColor: colors.orangeLightest,
            },
        },
        danger: {
            backgroundColor: colors.red,
            color: colors.white,
            '&:hover': {
                backgroundColor: colors.redLight,
            },
            '&:active': {
                backgroundColor: colors.redDark,
            },
            '&:disabled': {
                backgroundColor: colors.redLightest,
            },
        },
        info: {
            backgroundColor: colors.blue,
            color: colors.white,
        },
        container: {
            background: 'none',
            borderColor: 'transparent',
        },
    });
    var tagVariants = merge({}, defaultTagVariants, {
        blue: {
            backgroundColor: colors.blue,
            color: colors.blueDark,
        },
        gray: {
            backgroundColor: colors.grey,
            color: colors.greyDark,
        },
        gold: {
            backgroundColor: colors.gold,
            color: colors.goldDark,
        },
        red: {
            backgroundColor: colors.red,
            color: colors.redDark,
        },
        orange: {
            backgroundColor: colors.orange,
            color: colors.orangeDark,
        },
        green: {
            backgroundColor: colors.green,
            color: colors.greenDark,
        },
    });
    var breakpoints = ((customTheme === null || customTheme === void 0 ? void 0 : customTheme.breakpoints) || defaultBreakpoints);
    breakpoints.xs = breakpoints[0];
    breakpoints.sm = breakpoints[1];
    breakpoints.md = breakpoints[2];
    breakpoints.lg = breakpoints[3];
    breakpoints.xl = breakpoints[4];
    return __assign(__assign({}, defaultTheme), { colors: colors,
        breakpoints: breakpoints, typography: __assign(__assign({}, defaultTheme.typography), { color: colors.black }), variants: __assign(__assign({}, defaultTheme.variants), { Alert: badgeVariants, Badge: badgeVariants, Button: buttonVariants, Tag: tagVariants }) });
};
//# sourceMappingURL=createTheme.js.map